import { render, staticRenderFns } from "./canvasCode.vue?vue&type=template&id=8cebdec6"
import script from "./canvasCode.vue?vue&type=script&lang=js"
export * from "./canvasCode.vue?vue&type=script&lang=js"
import style0 from "./canvasCode.vue?vue&type=style&index=0&id=8cebdec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports